export default function reducer(state = {
    data: null
}, action) {
    switch (action.type) {
        case "STORE_DASHBOARD_DATA": {
            return { ...state, data: action.data }
        }
        default:
            break;
    }
    return state;
}
